import React from 'react'
import ListCompanyItem from '../molecules/ListCompanyItem'
import { CompanyItems } from '../../../domain/company'

interface ListCompanyProps {
    companies: CompanyItems[]
    onCompanyClick: (company: CompanyItems) => void
    searchValue?: string
}

const ListCompany: React.FC<ListCompanyProps> = ({
    companies,
    onCompanyClick,
    searchValue = '',
}) => {
    const filteredCompanies = companies.filter((company) =>
        company.name.toLowerCase().includes(searchValue.toLowerCase())
    )

    return (
        <div className="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4">
            {filteredCompanies.length > 0 ? (
                filteredCompanies.map((company) => (
                    <ListCompanyItem
                        key={company.id}
                        company={company}
                        onClick={onCompanyClick}
                    />
                ))
            ) : (
                <div className="text-center py-8 text-gray-500">
                    No se encontraron empresas que coincidan con "{searchValue}"
                </div>
            )}
        </div>
    )
}

export default ListCompany
